import { Spinner, SpinnerProps } from '@chakra-ui/react'
import React from 'react'

export const PrimarySpinner: React.FC<SpinnerProps> = React.forwardRef(
  (props: SpinnerProps, ref: React.Ref<any>) => (
    <Spinner ref={ref} color="brandPrimary" {...props} />
  )
)
